module.exports = __webpack_public_path__ + "static/media/icon-male.fe79054a.svg";